import React, {FC, useCallback, useEffect, useMemo, useState} from "react";
import {connect} from "react-redux";
import pluralize from 'pluralize';
import classNames from "classnames"
import {findIndexOfProductImageFrom} from "../../../helpers/productHelper";
import {
  AllInterferometricStacksType,
  InterferometricStackType,
  ProductImageStacType,
  SearchResultElementType, SearchResultsType
} from "../../../types/product";
import {updateSelectedProductsDispatchAction} from "../../../state/product/dispatchActions";
import {getSearchFormValuesByState} from "../../../helpers/configurationHelper";
import {ConfigurationsType} from "../../../types/configurations";
import {setCurrentMasterItemAction, storeSearchResultDetailsAction, updateFormDataPayloadAction} from "../../../state/application/actions";
import {QuicklookPreviewType} from "../../../types/geoMap";
import {
  getAllQuicklookPreviewsFromProductImages,
  getQuicklookPreviewInformationFrom,
  toggleQuicklookPreviewFrom
} from "../../../helpers/quicklookPreviewHelper";
import {updateQuicklookPreviewsAction} from "../../../state/geoMap/actions";
import {
  isInterferometricStackSearchResults,
  isProductImageSearchResultElement, isSelectableProductImage
} from "../../../helpers/searchResultsHelper";
import {
  findIndexOfInterferometricStackFrom, findInterferometricStackFrom,
  getAllInterferometricStacksSelected, getInterferometricStackItemsCount, getInterferometricStackItemsSelected,
  getInterferometricStackItemsSelectedCount,
} from "../../../helpers/interferometricStackHelper";
import {ShapeType} from "../../../types/shape";
import {AllQuicklookPreviewsType} from "../../../state/geoMap/types";
import {CartOrderType} from "../../../types/cart";
import FooterButtons from "../search-results-sidebar/shared/FooterButtons";
import translations from "../../../translations";

interface ContainerPropsType {
  configurations: ConfigurationsType,
  searchResults: SearchResultsType,
  searchFormValues: any,
  searchResultDetails: SearchResultElementType,
  selectedProducts: ProductImageStacType[],
  allQuicklookPreviews: AllQuicklookPreviewsType,
  allInterferometricStacks: AllInterferometricStacksType,
  ordersSubmitted: CartOrderType[],
  updateSelectedProductsActionHandler: (
    configurations: ConfigurationsType,
    searchFormValues: any,
    selectedArea: ShapeType,
    isInterferometricStackSearch: boolean,
    items:ProductImageStacType[],
    isChecked: boolean,
    language: string
  ) => {},
  storeSearchResultDetailsActionHandler: any,
  updateQuicklookPreviewsActionHandler: any,
  selectedArea: ShapeType,
  language: string,
  formData: any,
  updateFormDataPayloadActionHandler: any,
  setCurrentMasterItemActionHandler: any,
  isProductDetailsCase?: boolean,
  isInterferometricStackCase?: boolean,
}

const FooterSearchResultDetailsSidebarContainer = ({
  configurations,
  searchResults,
  searchFormValues,
  searchResultDetails,
  selectedProducts,
  allQuicklookPreviews,
  allInterferometricStacks,
  ordersSubmitted,
  updateSelectedProductsActionHandler,
  storeSearchResultDetailsActionHandler,
  updateQuicklookPreviewsActionHandler,
  selectedArea,
  language,
  formData,
  updateFormDataPayloadActionHandler,
  setCurrentMasterItemActionHandler,
  isProductDetailsCase,
  isInterferometricStackCase,
}: ContainerPropsType) => {
  const item = useMemo(
    () => isProductImageSearchResultElement(searchResultDetails)
      ? searchResultDetails as ProductImageStacType
      : null,
  [isProductImageSearchResultElement, searchResultDetails]);

  const isBaselineFilterMasterItem = item ? !!item?.isMasterItem : false;

  const isMaster = useMemo(
    () => {
      if (!item) {return false}
      return formData.masterId === item.id!
    },
    [formData.masterId, item]
  );

  const setProdImgAsMaster = (value: boolean, item: ProductImageStacType) => {
    updateFormDataPayloadActionHandler({
      masterId: value ? item.id : null
    });

    setCurrentMasterItemActionHandler(item);
  }

  const toggleAsMaster = useCallback((isSelected?:boolean) => {
    if (!item) return;

    setProdImgAsMaster(!isMaster, item);

    // Master item must be selected
    if (!isSelected && !isMaster) {
      updateSelectedProductsActionHandler(
        configurations,
        searchFormValues,
        selectedArea,
        isInterferometricStackSearch,
        [item],
        true,
        language
      );
    }

  }, [isMaster, item, setCurrentMasterItemActionHandler, updateFormDataPayloadActionHandler]);




  const isInterferometricStackSearch = isInterferometricStackSearchResults(searchResults);
  let footerSearchResultDetailsSidebarProps: any = {
    updateFormDataPayloadActionHandler,
    onChangeSearchResult: (searchResult) => storeSearchResultDetailsActionHandler(searchResult)
  };

  if (isProductImageSearchResultElement(searchResultDetails)) {
    const productImage = searchResultDetails as ProductImageStacType;
    let selectedElements = selectedProducts;
    if (isInterferometricStackSearch) {
      const stack = findInterferometricStackFrom(allInterferometricStacks, productImage);
      selectedElements = !!stack
        ? getInterferometricStackItemsSelected(stack, selectedProducts)
        : []
    }
    const onSelectSearchResult = isSelectableProductImage(configurations, ordersSubmitted, productImage)
      ? (isSelected) => {
        updateSelectedProductsActionHandler(
          configurations,
          searchFormValues,
          selectedArea,
          isInterferometricStackSearch,
          [productImage],
          isSelected,
            language
        );

        if (!isSelected && isMaster) {
          setProdImgAsMaster(false, productImage);
        }

        const {
          productImageQuicklookPreview,
          isQuicklookPreviewShownInMap
        } = getQuicklookPreviewInformationFrom(allQuicklookPreviews, productImage);
        if (!isSelected && isQuicklookPreviewShownInMap && productImageQuicklookPreview) {
          updateQuicklookPreviewsActionHandler([
            toggleQuicklookPreviewFrom(productImageQuicklookPreview, false)
          ]);
        }
      } : null
    footerSearchResultDetailsSidebarProps = {
      ...footerSearchResultDetailsSidebarProps,
      elementName: 'item',
      selectedElements,
      currentIndex: findIndexOfProductImageFrom(selectedElements, productImage),
      onSelectSearchResult
    }
  } else {
    const stack = searchResultDetails as InterferometricStackType;
    const imageSelectedCount = getInterferometricStackItemsSelectedCount(stack, selectedProducts);
    const totalImagesCount = getInterferometricStackItemsCount(stack);
    const selectedElements = getAllInterferometricStacksSelected(allInterferometricStacks, selectedProducts);

    const currentItem = stack.items[findIndexOfInterferometricStackFrom(selectedElements, stack)];

    const onSelectSearchResult = stack.items.some((productImage) => isSelectableProductImage(configurations, ordersSubmitted, productImage))
      ? (isSelected) => {
        updateSelectedProductsActionHandler(
          configurations,
          searchFormValues,
          selectedArea,
          isInterferometricStackSearch,
          stack.items,
          isSelected,
            language
        );

        const isCurrentItemMaster = currentItem?.id === formData.masterId;

        if (isSelected && !isCurrentItemMaster) {
          setProdImgAsMaster(false, currentItem);
        }

        if (!isSelected) {
          const allQuicklook = getAllQuicklookPreviewsFromProductImages(allQuicklookPreviews, stack.items)
            .map((quicklookPreview: QuicklookPreviewType) => toggleQuicklookPreviewFrom(quicklookPreview, false));
          updateQuicklookPreviewsActionHandler(allQuicklook);
        }


      } : null
    footerSearchResultDetailsSidebarProps = {
      ...footerSearchResultDetailsSidebarProps,
      elementName: 'stack',
      selectedElements,
      currentIndex: findIndexOfInterferometricStackFrom(selectedElements, stack),
      elementSelectedDescription: `${imageSelectedCount}/${totalImagesCount} selected`, // ${pluralize('image', imageSelectedCount)}
      onSelectSearchResult
    }
  }

  return <FooterSearchResultDetailsSidebar {...footerSearchResultDetailsSidebarProps} {...{isMaster, toggleAsMaster, formData, isProductDetailsCase, isInterferometricStackCase, isBaselineFilterMasterItem}} />;
};

interface FooterSearchResultDetailsSidebarProps {
  selectedElements: SearchResultElementType[],
  language: string,
  currentIndex: number,
  elementName: string,
  elementSelectedDescription?: string,
  onSelectSearchResult: any,
  onChangeSearchResult: any,
  isMaster: boolean,
  toggleAsMaster: (isSelected?:boolean) => void,
  formData: {[key:string]: any},
  isProductDetailsCase?: boolean,
  isInterferometricStackCase?: boolean,
  isBaselineFilterMasterItem?: boolean,
  updateFormDataPayloadActionHandler: any
}

const FooterSearchResultDetailsSidebar = ({
  selectedElements,
  language,
  currentIndex,
  elementName,
  elementSelectedDescription,
  onSelectSearchResult,
  onChangeSearchResult,
  isMaster,
  toggleAsMaster,
  formData,
  isProductDetailsCase,
  isInterferometricStackCase,
  isBaselineFilterMasterItem,
  updateFormDataPayloadActionHandler
}: FooterSearchResultDetailsSidebarProps) => {

  const [maxBaselineInputValue, setMaxBaselineInputValue] = useState(`${formData.maxBaseline || ""}`);
  const [isMaxBaselineInvalid, setIsMaxBaselineInvalid] = useState(false);
  const onChangeBaselineInput = (e:React.ChangeEvent<HTMLInputElement>): void => {
    const stringedMaxBaseline = e?.target?.value;

    const maxBaseline = Number(stringedMaxBaseline);
    const invalidMaxBaseline = Number.isNaN(maxBaseline);

    if (invalidMaxBaseline || stringedMaxBaseline === undefined) return;
    if (stringedMaxBaseline[0] === "0") return;

    setMaxBaselineInputValue(stringedMaxBaseline);
  }

  useEffect(() => {
    const newValue = Number(maxBaselineInputValue);
    const maxBaseline = newValue || undefined;

    const updateStore = setTimeout(() => {
      updateFormDataPayloadActionHandler({
        maxBaseline
      });
    }, 300);

    return () => clearTimeout(updateStore);
  }, [maxBaselineInputValue, updateFormDataPayloadActionHandler]);

  const totalElements = selectedElements.length;

  const isElementSelected = currentIndex >= 0;
  let prevIndex = totalElements - 1;
  let nextIndex = 0;
  if (isElementSelected) {
    prevIndex = (currentIndex - 1) >= 0
      ? (currentIndex - 1)
      : totalElements - 1;
    nextIndex = (currentIndex + 1) < totalElements
      ? (currentIndex + 1)
      : 0;
  }

  const onChangeCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!onSelectSearchResult) return;
    // Master can't be deselected during baseline-filtering
    if (isBaselineFilterMasterItem) return;
    if (isMaster && isElementSelected) {
      // Master can't be not selected
      toggleAsMaster(isElementSelected);
    }

    onSelectSearchResult(e.target.checked);
  }

  const MasterButton = () => {
    if (elementSelectedDescription) return <></>;
    return (
      <div className="col-3 product-action-buttons-container">
        <button
          type="button"
          className={classNames("baseline-filter-button remove-btn-defaults", {
            selected: isMaster
          })}
          onClick={() => toggleAsMaster(isElementSelected)}
        >
          Master
        </button>
      </div>
    )
  };

  const isCheckboxDisabled = !onSelectSearchResult || isBaselineFilterMasterItem;
  const isChecked = isElementSelected || isBaselineFilterMasterItem;

  return (<>
    <div className="search-result-details-footer row mx-0 px-3 py-4">
      <div className={elementSelectedDescription ? (totalElements === 0 ? "col-3" : "col-2") : "col-3"}>
        <div className="checkbox-container product-selected-checkbox-container">
          <input
            type="checkbox"
            className="product-selected-checkbox d-none"
            id="productSelectedCheckbox"
            name="productSelectedCheckbox"
            checked={isChecked}
            disabled={isCheckboxDisabled}
            onChange={onChangeCheckbox}
          />

          <label
            className={classNames("checkbox-label product-selected-label", {
              checked: isChecked,
              disabled: isCheckboxDisabled,
            })}
            htmlFor="productSelectedCheckbox"
          >
            <svg><use xlinkHref="#checkmark-icon" fill="#ffffff" /></svg>
          </label>

          <span className="product-selected-description">
           {elementSelectedDescription}
          </span>
        </div>
      </div>

      {/* max baseline */}
      {isInterferometricStackCase &&
          <div className={"col-4 d-flex align-items-start justify-content-end"} style={{position: 'relative', top: '-3px'}}>
            <div style={{display: "flex", flexDirection: "column"}}>
              <span style={{fontSize: "smaller"}}>{translations("maxBaseline", language)}</span>
              <input
                  value={maxBaselineInputValue}
                  className={`form-control ${isMaxBaselineInvalid ? "is-invalid" : ""}`}
                  onChange={onChangeBaselineInput}
                  placeholder={translations("enterValue", language)}
              />
            </div>
          </div>}

      {isProductDetailsCase && MasterButton()}

      <FooterButtons
        containerClassName={(totalElements !== 0 ? "col-3" : "col-4") + ` ${isProductDetailsCase ? 'd-none' : ''}`}
        formData={formData}
        detailsSidebarCase
        isProductDetailsCase
      />

      {
      <div className={elementSelectedDescription ? "col-3" : "col-5"}>

        <div
            className={classNames("nav-container", {
              "d-none": totalElements === 0
            })}
        >
          <button
              type="button"
              className="nav-button remove-btn-defaults"
              disabled={totalElements <= 1 && isElementSelected}
              onClick={() => onChangeSearchResult(selectedElements[prevIndex])}
          >
            <svg>
              <use xlinkHref="#left_arrow-icon" fill="#9A9BA6"/>
            </svg>
          </button>

          <div
              className={classNames("nav-paragraph my-0 mx-1", {
                "py-2": !isElementSelected
              })}
          >
            {
                isElementSelected && (
                    <p className="d-block m-0">
                      {`${currentIndex + 1} of`}
                    </p>
                )
            }
            <p className="mb-0 mt-1">
              {pluralize(`selected ${elementName}`, totalElements, true)}
            </p>
          </div>

          <button
              type="button"
              className="nav-button remove-btn-defaults pr-0"
              disabled={totalElements <= 1 && isElementSelected}
              onClick={() => onChangeSearchResult(selectedElements[nextIndex])}
          >
            <svg>
              <use xlinkHref="#right_arrow-icon" fill="#9A9BA6"/>
            </svg>
          </button>
        </div>
      </div>
    }
    </div>


  </>)
};

const mapStateToProps = (state) => ({
  configurations: state.application.configurations,
  searchFormValues: getSearchFormValuesByState(state),
  searchResults: state.product.searchResults,
  allQuicklookPreviews: state.geoMap.allQuicklookPreviews,
  selectedArea: state.geoMap.lastShape,
  ordersSubmitted: state.cart.ordersSubmitted,
  language: state.application.appParameters.language,
  formData: state.application.formData,
});

const mapDispatchToProps = (dispatch) => ({
  updateSelectedProductsActionHandler: (configurations, searchFormValues, selectedArea, isInterferometricStackSearch, products, add, language) => dispatch(updateSelectedProductsDispatchAction(configurations, searchFormValues, selectedArea, isInterferometricStackSearch, products, add, language)),
  storeSearchResultDetailsActionHandler: (item) => dispatch(storeSearchResultDetailsAction(item)),
  updateQuicklookPreviewsActionHandler: (quicklookPreviews) => dispatch(updateQuicklookPreviewsAction(quicklookPreviews)),
  updateFormDataPayloadActionHandler: (formDataPayload) => dispatch(updateFormDataPayloadAction(formDataPayload)),
  setCurrentMasterItemActionHandler: (masterItem) => dispatch(setCurrentMasterItemAction(masterItem)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FooterSearchResultDetailsSidebarContainer)
